import ActionTypes from '../constants/ActionTypes';
import { State } from '../reducers';

export function getRecommendationsBySite(state: State, key: number) {
  return state.recommendations.list[key].recommendations || [];
}

export function areRecommendationsLoaded(state: State, key: number) {
  return !!(
    state.recommendations.status[key] &&
    state.recommendations.status[key] === ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS
  );
}
